import styles from "./avatar-with-actions.module.css";

import { useState, useMemo } from "react";
import { Avatar, Upload, message, Spin, Modal } from "antd";

import CameraIcon from "@/icons/CameraIcon";
import EditIcon from "@/icons/EditIcon";
import TrashIcon from "@/icons/TrashIcon";

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 МБ

const AvatarWithActions = ({ user = {}, saveAvatar, deleteAvatar }) => {
  const [loading, setLoading] = useState(false);

  const handleAddAvatar = async (file) => {
    if (file.size > MAX_FILE_SIZE) {
      message.error("Максимальный размер файла — 2 МБ");
      return Upload.LIST_IGNORE;
    }

    setLoading(true);
    try {
      await saveAvatar(file);
    } catch (err) {
      message.error("Не удалось загрузить аватар");
    } finally {
      setLoading(false);
    }

    return false;
  };

  const handleDeleteAvatar = () => {
    Modal.confirm({
      title: `Вы уверены, что хотите удалить аватар?`,

      onOk() {
        handleConfirmDelete();
      },
      okText: "Удалить",
      cancelText: "Отмена",
    });
  };

  const handleConfirmDelete = async () => {
    if (loading) return;

    setLoading(true);
    try {
      await deleteAvatar();
    } catch (err) {
      message.error("Не удалось удалить аватар");
    } finally {
      setLoading(false);
    }
  };

  const initials = useMemo(() => {
    return `${user.lastname?.[0] ?? ""}${user.firstname?.[0] ?? ""}`;
  }, [user]);

  return (
    <div className={styles.avatar_wrapper}>
      <Spin spinning={loading} size="small">
        <Avatar
          size={48}
          src={user.avatar}
          style={{
            color: "#f56a00",
            backgroundColor: "#fde3cf",
            border: "none",
            textTransform: "uppercase",
          }}
        >
          {initials}
        </Avatar>
      </Spin>

      <div className={styles.avatar_overlay}>
        <Upload
          showUploadList={false}
          beforeUpload={handleAddAvatar}
          accept="image/jpeg,image/png"
          disabled={loading}
        >
          <span className={styles.icon_btn}>
            {user.avatar ? <EditIcon /> : <CameraIcon />}
          </span>
        </Upload>

        {user.avatar && (
          <span className={styles.icon_btn} onClick={handleDeleteAvatar}>
            <TrashIcon />
          </span>
        )}
      </div>
    </div>
  );
};

export default AvatarWithActions;
